/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AttachGachaEnhancementToGachaFromBackpackResponse } from '../../models/attach-gacha-enhancement-to-gacha-from-backpack-response';
import { GachaServiceAttachGachaEnhancementToGachaFromBackpackRequest } from '../../models/gacha-service-attach-gacha-enhancement-to-gacha-from-backpack-request';

export interface GachaServiceAttachGachaEnhancementToGachaFromBackpack$Params {
  userUuid: string;
  gachaInstanceId: string;
      body: GachaServiceAttachGachaEnhancementToGachaFromBackpackRequest
}

export function gachaServiceAttachGachaEnhancementToGachaFromBackpack(http: HttpClient, rootUrl: string, params: GachaServiceAttachGachaEnhancementToGachaFromBackpack$Params, context?: HttpContext): Observable<StrictHttpResponse<AttachGachaEnhancementToGachaFromBackpackResponse>> {
  const rb = new RequestBuilder(rootUrl, gachaServiceAttachGachaEnhancementToGachaFromBackpack.PATH, 'post');
  if (params) {
    rb.path('userUuid', params.userUuid, {});
    rb.path('gachaInstanceId', params.gachaInstanceId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AttachGachaEnhancementToGachaFromBackpackResponse>;
    })
  );
}

gachaServiceAttachGachaEnhancementToGachaFromBackpack.PATH = '/api/v3/gateway/user/{userUuid}/gacha/{gachaInstanceId}/enhancement';
